export class Language {
    constructor(public culture: string, public name: string, public abvreiation: string) {}
}
